import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ServiceConflictDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onKeepBoth: () => void;
  onReplace: () => void;
  locationName: string;
  serviceCount: number;
}

export function ServiceConflictDialog({
  isOpen,
  onClose,
  onKeepBoth,
  onReplace,
  locationName,
  serviceCount,
}: ServiceConflictDialogProps) {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mb-2 flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-full bg-yellow-100">
              <AlertTriangle className="h-5 w-5 text-yellow-600" />
            </div>
            <AlertDialogTitle>Existing Services Found</AlertDialogTitle>
          </div>
          <AlertDialogDescription asChild>
            <div className="space-y-3">
              <p>
                <strong>{locationName}</strong> already has{" "}
                <strong>
                  {serviceCount} manually-added service{serviceCount > 1 ? "s" : ""}
                </strong>
                .
              </p>
              <p>How would you like to handle the existing services when attaching this bid?</p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex-col gap-2 sm:flex-row">
          <AlertDialogCancel onClick={onClose}>Cancel</AlertDialogCancel>
          <Button variant="outline" onClick={onKeepBoth}>
            Keep Both
          </Button>
          <Button variant="destructive" onClick={onReplace}>
            Replace with Bid Services
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
